import { Event } from '@/feature/event-details-sbk/types';
import { TeamOrder } from '@/utils/sport-utils';

import { MatchupCardLayout } from '../MatchupCardLayout';
import { TeamInfoRow } from '../parts/TeamInfoRow';
import { TieInfoRow } from '../parts/TieInfoRow';
import { useIsMatchupLive } from '../use-is-matchup-live';
import { useMatchupTeamRows } from '../use-matchup-team-rows';
import { MarketColumn } from '../utils';

type SoccerMatchupCardProps = {
    event: Event;
    marketColumns: MarketColumn[];
    totalRows: number;
    teamOrder: TeamOrder;
    showHeader?: boolean;
    isLastItem?: boolean;
    onPress?: () => void;
};

// Soccer dynamic card: two team rows plus the Draw row for 3-way result markets.
export const SoccerMatchupCard = ({
    event,
    marketColumns,
    totalRows,
    teamOrder,
    showHeader,
    isLastItem,
    onPress,
}: SoccerMatchupCardProps) => {
    const isLive = useIsMatchupLive(event);
    const teamInfoRows = useMatchupTeamRows(event, teamOrder);

    return (
        <MatchupCardLayout
            event={event}
            marketColumns={marketColumns}
            totalRows={totalRows}
            teamOrder={teamOrder}
            showHeader={showHeader}
            isLastItem={isLastItem}
            onPress={onPress}
        >
            {teamInfoRows.map(teamInfo => (
                <TeamInfoRow key={teamInfo.side} {...teamInfo} event={event} isLive={isLive} />
            ))}
            <TieInfoRow />
        </MatchupCardLayout>
    );
};
